import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';
import englishLocaleData from 'react-intl/locale-data/en';
import arabicLocaleData from 'react-intl/locale-data/ar';

import { storeTranslation, geti18n, stepAction } from 'shared/store/actions';
import ReactLoading from 'react-loading';
// import { PageLoader } from 'pages';

addLocaleData(englishLocaleData);
addLocaleData(arabicLocaleData);

class MapIntlProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    this.timeOut = undefined;
  }

  async componentDidMount() {
    await this.props.onGetI18n();
    await this.hideLoader();

    if (this.props.token) this.props.onGetStepsProgress();
  }

  componentWillUnmount() {
    clearTimeout(this.timeOut);
  }

  hideLoader = () => {
    this.timeOut = setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  }

  render() {
    const { messages, locale, children } = this.props;
    const { loading } = this.state;

    return (
      <IntlProvider
        locale={locale}
        messages={messages[locale]}
      >
        {loading ? (
          <section className="page-loader">
            <ReactLoading height="44px" width="44px" color="#00599b" type="spin" />
          </section>
        ) : children}
      </IntlProvider>
    );
  }
}

// const mapStateToProps = (state) => {
//   const { locale, messages } = state.languageReducer.language;
//   return { key: locale, locale, messages };
// };

const mapStateToProps = ({ languageReducer: { language }, authReducer: { token } }) => ({
  messages: language.messages,
  locale: language.locale,
  token,
});

const mapDispatchToProps = dispatch => ({
  onStoreTranslation: () => dispatch(storeTranslation()),
  onGetI18n: () => dispatch(geti18n()),
  onGetStepsProgress: () => dispatch(stepAction.getProgress()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapIntlProvider);
